import * as React from "react";
import {ProductsEnum} from "@ferry/journey-services";
import {Link} from "react-router-dom";
import {getAmountWithDecimalDigits} from "../../CommonFunctions";
import * as moment from "moment/moment";
import {WarningBanner, resourcesHelper} from "@ferry/portal-core";

interface IProps {
    amount: number;
    policyNumber: string;
    policyStartDate: any
}

interface IState {
}

export class MigrationMissedPaymentBanner extends React.Component<IProps, IState> {

    constructor(props: any) {
        super(props);
        this.state = {}
    }

    public render(): React.ReactNode {
        const policyCancellationDate = moment.utc(this.props.policyStartDate, moment.ISO_8601).add(7, 'days');

        return (
            <div className="inner-container">
                <WarningBanner wording={
                    <>
                        <p className="mb-0">
                            We didn’t receive payment of <span className="font-weight-semi-bold">{getAmountWithDecimalDigits(this.props.amount)}</span>{' '}
                            for your {resourcesHelper.THEME_NAME} car insurance policy. You can {' '}
                            <Link id={"payNow"}
                                  to={{pathname: `/dashboard/account/missedPolicyPayment/${this.props.policyNumber}`}}>
                                pay now
                            </Link>
                            , or we’ll cancel your cover on {policyCancellationDate.format("DD MMM YYYY")}, 23:59 (as per your terms and conditions).
                        </p>
                        <Link id={"payNow"} className={"btn btn-white-dashboard mb-0 mt-0"}
                              state={{
                                  verifyCardFailed: false,
                                  product: ProductsEnum.WOLF_MOTOR
                              }}
                              to={{
                                  pathname: `/dashboard/account/missedPolicyPayment/${this.props.policyNumber}`,
                              }}>
                            Pay {getAmountWithDecimalDigits(this.props.amount)} now
                        </Link>
                    </>
                }/>
            </div>
        );
    }
}
